module.exports = __webpack_public_path__ + "static/media/9.d7a0109e.png";